module.exports = __webpack_public_path__ + "static/media/matt.3a98f2cf.png";